/**
 * Apartment and Unit are one choice on every buying-preferences screen
 * (Christian Gravias, DOMA 13460623858: "Bring together Apartment/Unit as 1
 * category. On all the buying preferences tab make it 1 button to click
 * Apartment/Unit"). Matching already treats them as the same type.
 *
 * The tile saves "Apartment". A buyer who saved "Unit" before sees the tile
 * ticked, and unticking it clears both.
 */
export const APARTMENT_UNIT_ID = 'Apartment';
export const APARTMENT_UNIT_LABEL = 'Apartment/Unit';

const SAME_AS_APARTMENT = new Set(['apartment', 'unit', 'apartment/unit']);

const isApartmentLike = (value) => SAME_AS_APARTMENT.has(String(value || '').trim().toLowerCase());

/** Is this tile ticked, given what is saved? */
export const isTypeSelected = (selected = [], id) => (id === APARTMENT_UNIT_ID
  ? selected.some(isApartmentLike)
  : selected.includes(id));

/** The saved list after clicking one tile (without any commercial rule). */
export const toggleType = (selected = [], id) => {
  if (id === APARTMENT_UNIT_ID) {
    return selected.some(isApartmentLike)
      ? selected.filter((v) => !isApartmentLike(v))
      : [...selected, APARTMENT_UNIT_ID];
  }
  return selected.includes(id) ? selected.filter((v) => v !== id) : [...selected, id];
};
